import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEventKey, setLoggedIn } from '../../../stores/reducers/userData';
import RegisterPage from './RegisterPage';
import { Props } from './types';
import {
  checkAuthorization,
  getUserInfo,
  getEventRegistrationFields,
  // userLogout,
} from '../../../api';
import './index.sass';
import AlertModal from '../../Modals/AlertModal';
import routes from '../../../config/routes';
import { Preloader } from 'src/components/Elements/Preloader/Preloader';
import { getAllStyle } from '../../../stores/reducers/sections';

const Registration: FC<Props> = ({ className, bgSettings, sectionName, sectionId, sectionData }): ReactElement => {
  const [isNeedAuthorization, setIsNeedAuthorization] = useState(false);
  // const [guestInfo, setGuestInfo] = useState<{ email: string } | null>(null);
  const [registrationFields, setRegistrationFields] = useState(null);
  const [allowedEmailDomain, setAllowedEmailDomain] = useState<string | null>(null);
  const [eventRules, setEventRules] = useState(null);
  const eventKey = useSelector(getEventKey);
  const styles = useSelector(getAllStyle);
  const dispatch = useDispatch();
  const [alertModalData, setAlertModalData] = useState<{ isOpen: boolean; close: () => void; text: string; isRedirected?: boolean; }>({
    isOpen: false,
    close: () => setAlertModalData({ ...alertModalData, isOpen: false }),
    text: '',
  });

  useEffect(() => {
    // checkAuthorization(eventKey).then((checkRegistrationResponse) => {
    //   console.log('checkRegistrationResponse :>> ', checkRegistrationResponse);
    //   switch (checkRegistrationResponse.status) {
    //     case 200: {
    //       setAlertModalData((oldValue) => ({
    //         ...oldValue,
    //         isOpen: true,
    //         text: 'Поздравляем! Вы успешно зарегистрированы на мероприятие.',
    //         isRedirected: true
    //       }));
    //       break;
    //     }
    //     case 401: {
    //       getEventFields();
    //       break;
    //     }
    //     case 403: {
    //       userLogout(eventKey).then((response) => {
    //         if ([200, 204].includes(response.status)) {
    //           dispatch(setLoggedIn(false));
    //         } else {
    //           setAlertModalData((oldValue) => ({
    //             ...oldValue,
    //             isOpen: true,
    //             text: 'Возникла ошибка, повторите попытку позже',
    //           }));
    //         }
    //         getEventFields();
    //         getUserInfo(eventKey).then((res) => {
    //           if (res) setGuestInfo(res.info);
    //         });
    //       });
    //       break;
    //     }
    //     default:
    //       break;
    //   }
    // });
    getEventFields();

    
  }, [eventKey, dispatch]);

  function getEventFields(): void {
    getEventRegistrationFields(eventKey).then((response) => {
      if (response && Object.keys(response).length) {
        setRegistrationFields(response.registrationFields);
        setEventRules(response.moduleAuth);
        setAllowedEmailDomain(response.moduleAuth.allowedEmailDomain);
      } else {
        console.error('getEventRegistrationFields: bad response');
      }
    });
    setIsNeedAuthorization(true);
  };

  function callAlertModal(errorTitle: string, isRedirected = true): void {
    setAlertModalData((oldValue) => ({
      ...oldValue,
      isOpen: true,
      text: errorTitle,
      isRedirected,
    }));
  };

  return (
    <>
      <AlertModal
        isOpen={alertModalData.isOpen}
        close={alertModalData.close}
        text={alertModalData.text}
        redirect={alertModalData.isRedirected ? routes.HOME : ''}
      />
      {isNeedAuthorization ? (
        <RegisterPage
          className={className}
          bgSettings={bgSettings}
          sectionName={sectionName}
          sectionId={sectionId}
          // guestInfo={guestInfo}
          registrationFields={registrationFields}
          eventRules={eventRules}
          allowedEmailDomain={allowedEmailDomain}
          onDomainError={(errorTitle) => callAlertModal(errorTitle, false)}
          sectionData={sectionData!}
        />
      ) : (
        <Preloader styles={styles} />
      )}
    </>
  );
};

export default Registration;
